import { IconProps } from 'components/Icons/icon';
import { ReactComponent as Icon } from './dot.svg';

export default function FullSmallDot(props: IconProps) {
  return <Icon tw="fill-current" className={props.className} />;
}
